import React, { Fragment, useRef, useState, useEffect } from 'react';
import { translate } from '../Services/translation';
import constants from '../constants';
const hasNameOrChildren = (link) => link.name || (link.links || []).length > 0;

const GetImageLinks = ({ links, menuTopLinkIndex }) => {
  if (links.length > 0 && links[0].imageUrl?.length) {
    return (
      <Fragment>
        <section className="navbar-desktop__images">
          {links.length > 0 &&
            links.map((link, index) => (
              <div key={`${index}${menuTopLinkIndex}`}>
                {hasNameOrChildren(link) && (
                  <div>
                    <label
                      htmlFor={`navbar-desktop__images-radio${index}${menuTopLinkIndex}`}
                    >
                      <figure className="navbar-desktop__image-figure">
                        <a
                          className="navbar-desktop__image-link"
                          href={link.url}
                        >
                          <img
                            className="navbar-desktop__image-img"
                            src={link.imageUrl}
                            alt={link.extraInfo}
                          />
                          <figcaption className="navbar-desktop__image-figcaption">
                            {link.name}
                          </figcaption>
                        </a>
                      </figure>
                    </label>
                  </div>
                )}
              </div>
            ))}
        </section>
      </Fragment>
    );
  }
  return null;
};

const NavigationItemDesktop = ({
  links = [],
  contentLink = null,
  subLevel = 0,
  onLinkHover,
  onMouseLeaveLink,
  activeMegaMenu,
  menuTopLinkIndex = '',
}) => {
  const menuRef = useRef(null);
  const [mainMenuActive, setMainMenuActive] = useState(false);

  const toggleMenu = (e, isTopIcon = false) => {
    e.preventDefault();
    const classList = menuRef?.current?.classList;
    if (classList) {
      if (isTopIcon) {
        e.target.classList.toggle('navbar__menu--show');
        const $bodyEl = document.querySelector('body');
        if ($bodyEl) {
          if ($bodyEl.classList.contains('navbar__mobile-menu--active')) {
            const $activeMenu = document.querySelectorAll(
              '.navbar__menu--show'
            );

            if ($activeMenu) {
              $activeMenu.forEach((menu) => {
                menu.classList.remove('navbar__menu--show');
              });
            }
            $bodyEl.classList.toggle('navbar__mobile-menu--active');
            setMainMenuActive(false);
            return;
          }
          $bodyEl.classList.toggle('navbar__mobile-menu--active');
        }
      }
      classList.toggle('navbar__menu--show');
    }
    setMainMenuActive(!mainMenuActive);
  };

  const additionClass =
    contentLink && contentLink.attributes
      ? contentLink.attributes.cssValue
      : null;
  const selectedClass =
    activeMegaMenu === contentLink ? 'navbar-desktop__link--selected' : '';
  const hasChildren = links.length > 0;
  const hasChildrenClass = hasChildren ? 'has-children' : null;

  const getLowerLevelLinkCountClass = (amount) => {
    if (amount > 40) {
      return 'large';
    } else if (amount > 20) {
      return 'medium';
    }
    return 'small';
  };
  // menuTopLinkIndex++;

  if (!contentLink && links?.length < 1) {
    return null;
  }

  return (
    <Fragment>
      {contentLink && (
        <Fragment>
          <a
            className={`navbar-desktop__link ${selectedClass} ${
              hasChildrenClass || ''
            } ${additionClass || ''}`}
            href={contentLink.url || '#'}
            onMouseOver={() => {
              return onLinkHover(contentLink, links.length > 0);
            }}
            onMouseLeave={() => {
              return onLinkHover(null, false);
            }}
          >
            <span className="navbar-desktop__link-content">
              {contentLink.name}
            </span>
            {hasChildren && (
              <svg
                className="navbar-desktop__link-content-icon"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.9132 8.16328L10.6632 14.4133C10.5762 14.5007 10.4727 14.57 10.3587 14.6173C10.2447 14.6647 10.1226 14.689 9.99918 14.689C9.8758 14.689 9.75362 14.6647 9.63967 14.6173C9.52571 14.57 9.42222 14.5007 9.33512 14.4133L3.08512 8.16328C2.909 7.98716 2.81006 7.74829 2.81006 7.49922C2.81006 7.25015 2.909 7.01128 3.08512 6.83516C3.26124 6.65904 3.50011 6.56009 3.74918 6.56009C3.99826 6.56009 4.23713 6.65904 4.41325 6.83516L9.99997 12.4219L15.5867 6.83437C15.7628 6.65825 16.0017 6.55931 16.2507 6.55931C16.4998 6.55931 16.7387 6.65825 16.9148 6.83437C17.0909 7.0105 17.1899 7.24937 17.1899 7.49844C17.1899 7.74751 17.0909 7.98638 16.9148 8.1625L16.9132 8.16328Z"
                  fill="currentColor"
                />
              </svg>
            )}
          </a>
          {links.length > 0 && subLevel <= 1 && (
            <i
              className="navbar-desktop__icon--caret-right navbar-desktop__icon navbar-desktop__icon--open"
              onClick={toggleMenu}
            ></i>
          )}
        </Fragment>
      )}
      {links.length > 0 && (
        <div
          className={`navbar-desktop__menu ${
            subLevel === 1 && links.length > 0 && links[0].imageUrl?.length
              ? 'navbar-desktop__menu-images'
              : ''
          } ${
            subLevel === 1 && activeMegaMenu === contentLink
              ? 'navbar-desktop__active-mega-menu'
              : ''
          }`}
          onMouseOver={() => {
            if (subLevel === 1) {
              return onLinkHover(contentLink, links.length > 0);
            }

            return;
          }}
          onMouseLeave={() => {
            return onLinkHover(null, false);
          }}
          ref={menuRef}
        >
          {subLevel === 1 && (
            <GetImageLinks links={links} menuTopLinkIndex={menuTopLinkIndex} />
          )}
          {subLevel < 1 && (
            <ul
              className={`navbar-desktop__menu-links sub-level-${subLevel} sub-links-count-${
                links?.length || 0
              } ${
                subLevel === 2
                  ? getLowerLevelLinkCountClass(links?.length || 0)
                  : ''
              }`}
            >
              {links.length > 0 &&
                links.map(
                  (link, index) =>
                    hasNameOrChildren(link) && (
                      <Fragment key={`navItem${index}`}>
                        <li className="navbar-desktop__item">
                          {subLevel <= 1 && (
                            <NavigationItemDesktop
                              links={link.links}
                              contentLink={link}
                              subLevel={subLevel + 1}
                              menuTopLinkIndex={
                                menuTopLinkIndex + '-' + index + '-' + subLevel
                              }
                              {...{
                                onLinkHover,
                                onMouseLeaveLink,
                                activeMegaMenu,
                              }}
                            />
                          )}
                        </li>
                      </Fragment>
                    )
                )}
            </ul>
          )}
          {!contentLink && constants && constants.topLinkList && (
            <ul className="navbar-desktop__menu-links navbar-desktop__top-menu-links">
              {constants.topLinkList.map((link, index) => (
                <li className="navbar-desktop__item" key={`topItem${index}`}>
                  <a className="navbar-desktop__link" href={link.href}>
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </Fragment>
  );
};

export default NavigationItemDesktop;
